export function numberComparator(val1, val2) {
    val1 = formatNumber(val1);
    val2 = formatNumber(val2);
    return val1 - val2;
}

export function dateComparator(date1, date2) {
    val1 = dateToComparableNumber(date1);
    val2 = dateToComparableNumber(date2);
    dateDiff = val1 - val2;
    console.log(date1 + " " + date2 + " " + dateDiff);
    return dateDiff;
}

export function dateFormatter(params) {
    if(params.data){
        if(params.value=="Total"){
            return "<b>"+params.value+"</b>";
        } else if(params.value){
            if(dateColumnsToConsider.indexOf(params.colDef.headerName) > -1 && params.value!="Total" && dateColumnsToConsider.length>0) {
                return moment(new Date(params.value)).format('MMM, YY');
            } else {
                return params.value;
            }
        }else return 'Blanks';
    }
}

export function stringComparator(a, b) {
    a = a == 'Null' ? '' : a;
    b = b == 'Null' ? '' : b;
    a = getString(a);
    b = getString(b);
    if(a)
        var A = a.toLowerCase();
    else var A=null;
    if(b)
        var B = b.toLowerCase();
    else var B=null;
    if (A < B) {
        return -1;
    } else if (A > B) {
        return  1;
    } else {
        return 0;
    }
}
export function formatNumber(val) {
    if (val != null) {
        while (val.length > 0) {
            if (val.indexOf(',') === -1)
            {
                break;
            }
            val = val.replace(',', '');
        }
        return parseFloat(val);
    } else {
        return val;
    }
}

export function getString(str) {
    if(str)
        var i = str.indexOf('title="');
    else return str;
    if (i > 0) {
        var text = '';
        i += 7;
        while (str[i] != '"') {
            text = text.concat(str[i++]);
        }
        str = text;
    }
    return str;
}

export function dateToComparableNumber(date) {
    if (date === undefined || date === null) {
        return null;
    }
    var year = date.substring(0, 4);
    var month = date.substring(5, 7);
    var day = date.substring(8, 10);
    var hour = date.substring(11, 13);
    var min = date.substring(14, 16);
    var sec = date.substring(17, 18);

    return year * 1000000000 + month * 10000000 + day * 100000 + hour * 1000 + min * 10 + sec;
}

export function setBottomFormatting(bottomId) {
    bottomId = '#' + bottomId;
    jQuery(bottomId + ' .ag-body-viewport').css('overflow-y', 'hidden');
    jQuery(bottomId + ' #centerRow').css('height', '26');
    jQuery(bottomId + ' #center').css('height', '27');
    jQuery(bottomId + ' .ag-selection-checkbox').hide();
}
